// ── Shared brand (TPT217, TPT235, TPT288) ──
//
// The TipΔTask logo is the WORDMARK — `Tip` + an italic teal `Δ` + `Task` in
// Literata 800, exactly as the tipatask.com landing page nav renders it. There
// is no separate triangle mark anywhere in the UI: the wordmark already carries
// the delta, and the landing page never pairs the two in a lockup. Every place
// the SPA paints the brand (sidebar + the four logged-out shells) goes through
// here so the markup has one owner.
//
// INSIGNIA_* below are NOT rendered in-app. They are the solid-Δ geometry of the
// favicon / app-icon assets (icons/icon.svg, the rasters) — small-size artifacts
// where a wordmark is unreadable (TPT288). The shape IS the website wordmark's
// delta: Literata 800 U+0394 with the browser's synthetic italic (skewX -0.25 —
// website/public/css/marketing.css .tt-brand-delta asks for italic but loads only
// upright Literata), the same outline as ai/todo/server/scripts/gen-icon.js
// DELTA_PATH, normalized into a 0–100 viewBox at gen-icon's framing (longest side
// 780/1024 of the canvas). Two contours, outer Δ + triangular counter, filled
// evenodd so the counter stays open. The fill is the literal hex, never a theme
// variable: the style guide (ai/product/website-style-guide.md §9) pins it to
// #14B8A6 as a fixed constant.

export const INSIGNIA_TEAL = '#14b8a6';
export const INSIGNIA_PATH = 'M82.82,88.09 L13.49,88.09 L13.73,80.15 L56.66,11.91 L77.74,11.91 L86.51,80.26 Z M58.67,28.21 L30.71,74.39 L62.33,74.39 L58.99,28.21 Z';
export const INSIGNIA_FILL_RULE = 'evenodd';

// `Tip` + a styled `Δ` + `Task` (website-spec.md §13). `.brand-delta`
// (styles.css) supplies the italic teal delta.
export function wordmarkHtml() {
  return 'Tip<span class="brand-delta">Δ</span>Task';
}

// The wordmark's own delta, standing alone — the collapsed sidebar rail, where
// the label is hidden and this is the only brand left. Same glyph and same
// `.brand-delta` class as wordmarkHtml() so the two can never diverge.
// Decorative (aria-hidden): the row that holds it carries the accessible name.
// `className` is appended after the base class for placement hooks only.
export function brandDeltaGlyph({ className = '' } = {}) {
  const cls = className ? `brand-delta ${className}` : 'brand-delta';
  return `<span class="${cls}" aria-hidden="true">Δ</span>`;
}

// The logged-out shell's logo: the wordmark alone, as the page heading. Login,
// register, invite and reset-password all render this identical block. `.brand-lockup`
// (styles.css) carries the landing-derived type; the sidebar brand row wears the same
// class, so the two surfaces cannot drift apart.
export function brandLockup() {
  return `<div class="login-brand"><h1 class="brand-lockup">${wordmarkHtml()}</h1></div>`;
}
